import styled from 'styled-components';
import { lineHeight, theme, toRem } from 'design';
import { H4 } from '../Typography';

const PageLabel = styled(H4)`
  display: flex;
  flex-grow: 0;
  width: auto;
  font-size: ${toRem(theme.font.size.xxs)};
  line-height: ${lineHeight(theme.font.size.xxs)};
  color: ${theme.color.neutral[400]};

  @media (min-width: ${theme.breakpoint.med}px) {
    font-size: ${toRem(theme.font.size.sm)};
    line-height: ${lineHeight(theme.font.size.sm)};
  }
`;

export default PageLabel;
